<template>
  <v-navigation-drawer
    v-model="drawer"
    clipped
    app
    :mobile-breakpoint="
      $route.query.event && $route.name != 'btEvent' ? '1904' : '1360'
    "
    class="colorDominant grey darken-3 colorMenuLeftTheme"
  >
    <!-- progress para o btn languages quando em modo mobile -->
    <v-progress-linear
      v-if="$vuetify.breakpoint.xsOnly"
      absolute
      indeterminate
      :active="loading"
    >
    </v-progress-linear>

    <ButtonLanguages v-if="$vuetify.breakpoint.xsOnly" class="pa-2" />
    <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>

    <div class="pa-2">
      <Search />
    </div>

    <v-divider></v-divider>

    <!-- Main Menu Componente -->
    <mainMenu />
    <v-divider></v-divider>

    <!-- Special Menu Componente -->
    <specialMenu />
    <v-divider></v-divider>

    <!-- All Sports -->
    <v-list dense nav>
      <v-subheader class="overline"> {{ $t("allSports") }} </v-subheader>
      <v-list-group
        v-if="sport.id != 100"
        v-for="sport in sports"
        :key="`sport-${sport.id}`"
        v-model="sport.active"
        append-icon="mdi-menu-down"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <template v-if="sport.icon_img">
              <img class="mb-0" width="24px" :src="sport.icon_img" />
            </template>
            <v-icon v-else-if="!iconT(sport.id).custom">
              {{ iconT(sport.id).src }}
            </v-icon>
            <v-img
              v-else
              :src="iconT(sport.id).src"
              width="24"
              height="24"
              :style="sport.active ? filter : ''"
            ></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="sport.icon_img ? 'text-uppercase' : ''">
              {{ sport.name }} &nbsp;
              <v-chip x-small color="rgba(255,255,255,.12)">{{
                sport.total_events
              }}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-group
          v-for="category in sport.categories"
          :key="`category-${category.id}`"
          v-model="category.active"
          sub-group
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="category.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- todos -->
          <v-list-item
            class="pl-3"
            :to="{
              name: 'category',
              params: { sport: sport.id, category: category.id },
              query: {
                sport: sport.name,
                category: category.name,
              },
              hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
            }"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="d-block text-truncate" style="max-width: 150px"
                  >{{ $t("all") }} {{ category.name }}</span
                >
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip small color="rgba(255,255,255,.12)">{{
                category.total_by_category
              }}</v-chip>
            </v-list-item-icon>
          </v-list-item>
          <!-- / todos -->

          <!-- item -->
          <v-list-item
            class="pl-3"
            v-for="tournament in category.tournaments"
            :key="`tournament-${tournament.id}`"
            :to="{
              name: 'tournament',
              params: {
                sport: sport.id,
                category: category.id,
                tournament: tournament.id,
              },
              query: {
                sport: sport.name,
                category: category.name,
                tournament: tournament.name,
              },
              hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
            }"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="d-block text-truncate" style="max-width: 150px">{{
                  tournament.name
                }}</span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip
                small
                v-text="tournament.qtd_events"
                color="rgba(255,255,255,.12)"
              ></v-chip>
            </v-list-item-icon>
          </v-list-item>
          <!-- / item -->
        </v-list-group>
      </v-list-group>
    </v-list>
    <v-divider></v-divider>

    <!-- ConsultBet -->
    <v-subheader class="overline mt-4">{{ $t("consultBet") }}</v-subheader>
    <div class="mx-3" style="padding-bottom: 100px">
      <v-form v-model="valid" ref="formConsultBet" lazy-validation>
        <div class="d-flex">
          <v-text-field
            v-model="betNumber"
            clearable
            :label="$t('betCode')"
            solo-inverted
            required
            :rules="[(v) => !!v || '*Campo obrigatório.']"
            flat
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'max-width:290px'
                : 'padding-top:8px;'
            "
          ></v-text-field>
          <v-btn
            :disabled="!valid"
            type="submit"
            @click.prevent="consultBet"
            fab
            small
            class="ml-1 mt-1"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </v-form>

      <DialogConsultBet :data="dataConsultBet" />

      <!-- BANNERS -->
      <template v-if="banners.length > 0">
        <div
          class="d-flex flex-column"
          v-for="(banner, i) in banners"
          :key="`banner-${i}`"
        >
          <div
            class="d-flex align-center"
            style="overflow: hidden; max-width: 300px"
          >
            <a
              :href="banner.url"
              class="mb-3"
              :style="banner.url ? 'cursor:pointer' : 'cursor:auto'"
            >
              <v-img max-width="232" :src="banner.urlImg">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      size="16"
                      indeterminate
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </a>
          </div>
        </div>
      </template>
      <!-- / BANNERS -->
    </div>
  </v-navigation-drawer>
</template>

<script>
import mainMenu from "./main_menu_list.vue";
import specialMenu from "./special_menu_list.vue";
import { icon } from "@/components/icon-sport/icon.js";
import DialogConsultBet from "./dialog";
import ButtonLanguages from "@/components/btn-languages/btn-languages";
import axios from "axios";
import Search from "@/components/search/search";
const baseUrlS3 = "https://dozr8la71aog.cloudfront.net/";
export default {
  name: "menu-sidebar",
  props: ["drawer_prop"],
  components: {
    DialogConsultBet,
    ButtonLanguages,
    mainMenu,
    specialMenu,
    Search,
  },
  data() {
    return {
      drawer: null,
      loading: false,
      item: 0,
      sports: [],
      live: [],
      betNumber: "",
      dataConsultBet: [],
      valid: false,
      banners: [],
    };
  },
  computed: {
    casino() {
      return this.$store.state.operators.casino;
    },
    leftMenu() {
      return this.$store.state.leftMenu;
    },
    leftMenuEvents() {
      return this.$store.state.leftMenu.events;
    },
    filter() {
      return this.$customIconsActive(this.$vuetify.theme.themes.dark.primary);
    },
  },
  async mounted() {
    this.getListMenu(this.$store.state.operators.operator_id);
    // Se o Usuário chegar os site atraves de um link de conferência:
    if (this.$route.query.conf) {
      this.betNumber = this.$route.query.conf;
      this.consultBet();
    }

    // Consume MENU BANNERS
    const domain = this.$domain();
    const headers = {
      "Content-Type": "application/json",
    };

    const { isExpired, data } = await this.$localbase.get({
      type: "menuImages",
    });

    if (!isExpired && data) {
      this.banners = data;
      return;
    }

    const baseLambdaUrl = this.$lambdaUrl();

    axios.post(`${baseLambdaUrl}/s3/listImgsMenu`, { domain }, { headers: headers }).then((resp) => {
      const contents = resp.data;
      if (contents.length === 0) {
        this.$localbase.set({ type: "menuImages", data: [] });
        return;
      }
      contents.forEach((item) => {
        if (item.Size > 0) {
          let urlImg = baseUrlS3 + encodeURIComponent(item.Key);
          let url = this.$constructURL(item.Key);
          this.banners.push({ urlImg, url });
        }
      });

      this.$localbase.set({ type: "menuImages", data: this.banners });
    });
  },
  watch: {
    // Abertura do Drawer(recebendo por prop):
    drawer_prop: function(val) {
      this.drawer = val;
    },
    // Fechamento do Drawer:
    drawer: function(newVal) {
      this.$emit("update:drawer", newVal);
    },
    $route(newRoute, oldRoute) {
      // Requisitar lista de "Todos esportes" após troca de idioma se estiver em "Esportes"
      this.$route.name === "Sports" &&
        this.getListMenu(this.$store.state.operators.operator_id);

      // Fechando o menu se estiver na página de Cassino:
      // Close Menu Views:
      var closeMenu = ["casinoLobby"];

      if (closeMenu.includes(newRoute.name)) {
        this.drawer = false;
      }

      // Open Menu Views:
      // Abrir O menu Lateral Esquerdo
      // Se a rota anterior for a do cassino
      // E se for desktop
      // E se for uma das páginas do main appbar
      var openMenu = ["bigTable", "Sports", "live", "pendentsBets"];
      if (
        openMenu.includes(newRoute.name) &&
        closeMenu.includes(oldRoute.name) &&
        this.$vuetify.breakpoint.width > 1264
      ) {
        this.drawer = true;
      }
    },
  },
  methods: {
    // Recupera a Lista de Sports, Categories, Tournaments;
    getListMenu: function(idOperator) {
      this.loading = true;
      this.$axios
        .post(`main/leftMenu?id_operator=${idOperator}`)
        .then(async (resp) => {
          const { sports } = resp.data;
          const menuSports = await this.$handlerIconsImgSports(sports);
          this.sports = menuSports;
          this.putTotalEvents(this.sports);
          // var minutesToAdd = 10;
          // var currentDate = new Date();
          // var futureDate = new Date(
          //   currentDate.getTime() + minutesToAdd * 60000
          // ).toISOString();
          // Armazena o Dia ativo com sua respectiva tempo de expiração
          // this.$store.commit("setLeftMenu", {
          //   time: futureDate,
          //   events: this.sports,
          // });
        })
        .catch(() => {})
        .finally(() => (this.loading = false));
      // if (this.isExpired()) {
      // } else {
      //   // console.log("aqui no else")
      //   // this.putTotalEvents(this.leftMenuEvents);
      //   this.sports = this.leftMenuEvents
      //   this.putTotalEvents(this.leftMenuEvents)
      // }
    },
    // isExpired() {
    //   // Verifica se o Horário da Expirou
    //   // console.log("time expried", this.timeLeftMenuExpired)
    //   if (this.leftMenu.time != null) {
    //     var nowDate = new Date().toISOString()
    //     if (nowDate < this.leftMenu.time) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   } else {
    //     var minutesToAdd = 10;
    //     var currentDate = new Date()
    //     var futureDate = new Date(currentDate.getTime() + minutesToAdd * 60000).toISOString();
    //     // Armazena o Dia ativo com sua respectiva tempo de expiração
    //     this.$store.commit("setLeftMenu", {
    //       time: futureDate,
    //       events: null
    //     });
    //     return true;
    //   }
    // },
    putTotalEvents: function(arr) {
      const listCountrys = new Object();
      const listTournaments = new Object();
      for (const sport of arr) {
        let total = 0;
        for (const categories of sport.categories) {
          let total_by_category = 0;
          listCountrys[categories.id] = categories.name;
          for (const tournaments of categories.tournaments) {
            listTournaments[tournaments.id] = tournaments.name;
            total = total + Number(tournaments.qtd_events);
            total_by_category =
              total_by_category + Number(tournaments.qtd_events);
            this.$set(sport, "total_events", total);
            this.$set(categories, "total_by_category", total_by_category);
            this.$set(sport, "active", false);
            this.$set(categories, "active", false);
          }
        }
      }
      sessionStorage.setItem("listCountrys", JSON.stringify(listCountrys));
      sessionStorage.setItem(
        "listTournaments",
        JSON.stringify(listTournaments)
      );
    },
    consultBet: function() {
      if (!this.$refs.formConsultBet.validate() && !this.$route.query.conf) {
        return;
      }

      this.loading = true;
      this.$axios
        .post(
          `/main/confereceBet`,
          this.$formdata({
            domain: this.$domain(),
            id_bet: this.betNumber,
          })
        )
        .then((resp) => {
          this.dataConsultBet = resp.data;
        })
        .catch(() => {
          const msg = "Algo deu errado. Tente novamente.";
          const color = "warning";
          this.$store.commit("setNotification", {
            msg,
            color,
          });
        })
        .finally(() => (this.loading = false));
    },
    // Implementa o Icon correto por Sport
    iconT: function(id) {
      if (!icon(id)) {
        return {};
      }

      const sportIcon = icon(id);

      if (sportIcon.custom) {
        return { custom: true, src: this.getCustomIcon(sportIcon.src) };
      }

      return { custom: false, src: sportIcon };
    },
    getCustomIcon(fileName) {
      return require("@/assets/icons/" + fileName);
    },
  },
};
</script>
<style lang="css">
.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  .v-list-group--sub-group
  > .v-list-group__items
  > div
  > .v-list-item {
  padding-left: 16px !important;
}
</style>
